import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, user, loading } = useAuthContext();

  // Enquanto carrega, mostrar loading
  if (loading) {
    return (
      <div className="auth-loading">
        <div className="loading-spinner"></div>
        <p>Verificando acesso...</p>
      </div>
    );
  }

  // Se não autenticado ou não é admin, redirecionar
  if (!isAuthenticated || !user || !user.isAdmin) {
    return <Navigate to="/" replace />;
  }

  // Se autenticado e é admin, mostrar conteúdo
  return children;
};

export default ProtectedRoute;
